import { render, staticRenderFns } from "./RabattBlock.vue?vue&type=template&id=3cbdafc4&"
import script from "./RabattBlock.vue?vue&type=script&lang=js&"
export * from "./RabattBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports